<template>
    <div
        class="live-m"
        :class="{ horizontal: isHorizontal, horizontalFull: horizontalFull }"
        @touchmove="stopTouch"
        @click="isShowRewardPrice = false"
    >
        <div class="main" v-show="liveStatus === 1" @touchmove="stopTouch">
            <div class="loading-container">加载中...</div>
            <div class="player-container">
                <div v-if="!exceptionType" id="player-content"></div>
                <ExceptionView :mobile="true" :type="exceptionType" v-if="exceptionType" />
            </div>
            <div v-if="rewardNoticeText" class="reward-notice">
                <span>🎉🎉 {{ rewardNoticeText }}</span>
            </div>
            <img
                @click="onHorizontalFull"
                v-if="isHorizontal"
                :class="horizontalFull ? 'horizontal-full-btn-left' : ''"
                class="horizontal-full-btn"
                src="https://res.peki.vip/20220223/5643df7d2e5c4fff9bf60c03702d051b.png"
            />
            <div class="tab-list">
                <div
                    @click="onTabchange('chat')"
                    :class="`${activeTabItem === 'chat' && 'active-item'} ${isNewMessage.chat && 'new-message-icon'}`"
                >
                    互动
                </div>
                <div
                    @click="onTabchange('question')"
                    :class="`${activeTabItem === 'question' && 'active-item'} ${
                        isNewMessage.question && 'new-message-icon'
                    }`"
                >
                    问答
                </div>
                <div @click="onTabchange('invite')" :class="`${activeTabItem === 'invite' ? 'active-item' : ''}`">
                    邀请
                </div>
                <div v-if="!isHorizontal" @click="onResetPage" class="reset-page">刷新</div>
                <img
                    class="share-icon"
                    v-if="userClickShareBtn"
                    src="//res.peki.vip/20210622/3c0087688abe4d0d925f31174b26072f.png"
                    @click="onShowShareContainer"
                />
                <div
                    v-if="!envWebview && isWeixin && !isHorizontal"
                    @click.stop="isShowRewardPrice = true"
                    class="red-packet"
                >
                    赞
                </div>
                <div
                    :class="`setting ${activeTabItem === 'setting' ? 'active-item' : ''}`"
                    @click="onTabchange('setting')"
                >
                    <van-icon name="setting-o" />
                </div>
                <transition name="van-fade">
                    <div class="reward-price" @click.stop="" v-show="isShowRewardPrice">
                        <div
                            @click="onRewardPay(num)"
                            class="price-num"
                            v-for="num in ['2.00', '6.66', '8.88', '16.66', '18.88']"
                            :key="num"
                        >
                            ¥{{ num }}
                        </div>
                    </div>
                </transition>
            </div>
            <van-notice-bar
                v-if="isShowNotice"
                scrollable
                left-icon="volume-o"
                background="#FFB441"
                color="#fff"
                mode="closeable"
                @close="isShowNotice = false"
            >
                {{ noticeMessage || '公告栏' }}
            </van-notice-bar>
            <!-- 互动区 -->
            <div
                v-show="activeTabItem === 'chat'"
                :class="`chat-list ${iphoneX ? 'chat-list-iphoneX' : ''}`"
                @touchmove.stop="chatTouch"
                @click="onPreviewImage($event)"
            >
                <!-- 购买弹幕 -->
                <div class="barrage-container" v-if="liveStatus === 1">
                    <Barrage :barrageData="barrageData" />
                </div>
                <div class="list-content" ref="chatListContent">
                    <div ref="chatListBox">
                        <div class="list-item" v-for="item in chatList" :key="item.chatId">
                            <!-- 聊天信息 -->
                            <img
                                v-if="!item.thirdType && item.role === 'spadmin'"
                                class="user-avatar"
                                :src="item.avatar"
                            />
                            <img
                                v-else-if="!item.thirdType && item.role === 'admin'"
                                class="user-avatar"
                                :src="item.avatar"
                            />
                            <img
                                v-else-if="!item.thirdType"
                                class="user-avatar"
                                src="//res.peki.vip/20210428/1619583411829/1619583411826.png"
                            />
                            <div v-if="!item.thirdType">
                                <div class="user-info">
                                    <div class="user-name">{{ item.nickname }}</div>
                                    <div class="user-role1" v-if="item.uid === HT_userInfo.uid">(自己)</div>
                                    <div class="user-role2" v-if="item.role === 'spadmin'">(讲师)</div>
                                    <div class="user-role3" v-if="item.role === 'admin'">(助教)</div>
                                    <div class="message-time">{{ item.timeText }}</div>
                                </div>
                                <div
                                    class="chat-message"
                                    :class="{ 'admin-message': ['admin', 'spadmin'].includes(item.role) }"
                                    v-html="`<span>${item.msg}</span>`"
                                />
                            </div>
                            <!-- 广播信息 -->
                            <div class="broadcast-item" v-if="item.thirdType === 'broadcast'">
                                系统消息: <span v-html="item.msg"></span>
                            </div>
                            <!-- 自定义消息 - 商品下单 -->
                            <!-- <div class="userToPay-item" v-if="item.thirdType === 'userToPay'" v-html="item.msg"></div> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- 提问区 -->
            <div
                v-show="activeTabItem === 'question'"
                :class="`question-list ${iphoneX ? 'question-list-iphoneX' : ''}`"
                @touchmove.stop="onScrollMessage"
            >
                <div class="list-content">
                    <div class="list-item" v-for="item in questionList" :key="item.qid">
                        <img v-if="['spadmin', 'admin'].includes(item.role)" class="user-avatar" :src="item.avatar" />
                        <img
                            v-if="!['spadmin', 'admin'].includes(item.role)"
                            class="user-avatar"
                            src="../../images/user-avatar.png"
                        />
                        <div>
                            <div class="user-info">
                                <div class="user-name">{{ item.nickname }}</div>
                                <div class="user-role1" v-if="item.uid === HT_userInfo.uid">(自己)</div>
                                <div class="user-role2" v-if="item.role === 'spadmin'">(讲师)</div>
                                <div class="user-role3" v-if="item.role === 'admin'">(助教)</div>
                                <div class="message-time">{{ item.timeText }}</div>
                            </div>
                            <div class="chat-message question-message">
                                <div v-if="item.role === 'user'">{{ item.content }}</div>
                                <div v-if="item.role !== 'user'" v-html="`<span>${item.content}</span>`"></div>
                                <div v-if="item.answer">
                                    <div
                                        class="question-answer"
                                        v-for="answerItem in item.answer"
                                        :key="answerItem.qid"
                                    >
                                        <span>{{ answerItem.nickname }}</span>
                                        <span class="user-role2" v-if="answerItem.role === 'spadmin'">
                                            (讲师) 回复:
                                        </span>
                                        <span class="user-role3" v-if="answerItem.role === 'admin'">(助教) 回复: </span>
                                        <span v-html="answerItem.content"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 排行榜 -->
            <InviteRankingM
                v-if="activeTabItem === 'invite'"
                @showShareImg="onShowShareContainer"
                :liveCourse="{ id: courseId }"
            />
            <!-- 设置区 -->
            <div class="setting-container" v-show="activeTabItem === 'setting'">
                <div class="setting-item">
                    <span>直播线路: </span>
                    <div>
                        <van-button
                            class="network-btn"
                            @click="onLineChange(item)"
                            v-for="item in networkLineList"
                            :key="item.label"
                            :type="activeLine === item.key ? 'primary' : 'default'"
                        >
                            {{ item.label }}
                        </van-button>
                    </div>
                </div>
                <div class="setting-item">
                    <span>网络模式: </span>
                    <div>
                        <van-button
                            class="network-btn"
                            @click="onNetworkChange(item)"
                            v-for="item in networkModalList"
                            :key="item.val"
                            :type="activeNetwork === item.val ? 'primary' : 'default'"
                        >
                            {{ item.name }}
                        </van-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 聊天/提问输入框 -->
        <div
            v-show="liveStatus === 1 && ['chat', 'question'].indexOf(activeTabItem) !== -1"
            :class="`chat-dialog ${iphoneX || inputFocusStatus ? 'chat-dialog-iphoneX' : ''}`"
        >
            <textarea
                v-show="activeTabItem === 'chat'"
                v-model="chatMessage"
                @focus="inputFocusStatus = true"
                @blur="onTextareaBlur"
                :disabled="!isInputStatus"
                :placeholder="isInputStatus ? '请输入文字' : '禁言模式，暂时不能发言'"
            ></textarea>
            <div
                v-show="activeTabItem === 'chat'"
                :class="`submit-btn ${!isInputStatus ? 'disabled-btn' : ''}`"
                @click="onSubmitChat"
            >
                发送
            </div>
            <textarea
                v-show="activeTabItem === 'question'"
                v-model="questionMessage"
                @focus="inputFocusStatus = true"
                @blur="onTextareaBlur"
                placeholder="向老师提问吧"
            ></textarea>
            <div v-show="activeTabItem === 'question'" class="submit-btn" @click="onSubmitQuestion">发送</div>
        </div>
        <!-- 等待提示框 -->
        <div class="not-start" v-if="liveStatus === -1">
            <div class="course-info">
                <div class="title">{{ courseInfo.course_name }}</div>
                <div class="nickname">讲师：{{ courseInfo.nickname }}</div>
                <div class="count-down" v-if="countDownText">
                    距离直播开始还有
                    <span>{{ countDownText }}</span>
                    <br />
                    请耐心等待哦～
                </div>
                <div class="count-down" v-else>讲师正在赶来的路上</div>
            </div>
        </div>
        <!-- 抽奖 -->
        <LuckDraw
            :luckDrawUserName="luckDrawUserName"
            :luckDrawStatus="luckDrawStatus"
            v-on:closeLuckDraw="onSetLuckDrawStatus"
        />
        <!-- 商品推送 -->
        <CoursePackageList
            :courseNo="courseNo"
            :pushProductList="pushProductList"
            v-if="liveStatus === 1"
            @buyCoursePackage="onBuyCoursePackage"
        />
        <!-- 用户订单 -->
        <OrderVerifyM
            ref="orderVerifyM"
            :liveInfo="goodsCourseInfo"
            :coursePriceInfo="pushPackageInfo"
            :userInfo="userInfo"
        />
        <OrderDialog ref="orderDialog" />
        <!-- 邀请按钮 -->
        <template v-if="liveCoursePackage && liveCoursePackage.type === 1 && !envWebview">
            <div
                class="share-btn"
                v-if="activeTabItem !== 'invite' && !userClickShareBtn && liveStatus === 1"
                @click="onShowShareContainer"
            >
                <img src="https://res.peki.vip/20210622/3c0087688abe4d0d925f31174b26072f.png" />
                <span>邀请好友看课</span>
            </div>
        </template>
        <div class="share-container" v-show="isShowShareContainer" @click="isShowShareContainer = false">
            <img src="//res.peki.vip/20210611/a885b3a68a04415f83f5cccdf83f0dca.png" />
        </div>
        <AgmAffirm ref="agmAffirm" :mobile="true" />
    </div>
</template>

<script>
import liveInit from './liveInit.js'
import { isIphoneX, replaceUrl, timeToHourMins, getLivEmojions, isWeixin, urlQuery } from '@/utils/utils.js'
import { getLiveInfo, fetchOrder, wxPay, getLiveForbidden, liveHeart } from '@/utils/api.js'
import { timeNumToHMSText } from '@/utils/utils.js'
import { buyCoursepackage } from '@/utils/jsbrage.js'
import ExceptionView from '@/components/ExceptionView'
import OrderDialog from '@/components/orderVerify/Dialog'
import Barrage from '@/components/livePc/Barrage'
import LuckDraw from '@/components/livePc/LuckDraw'
import CoursePackageList from './components/CoursePackageList'
import OrderVerifyM from '@/components/OrderVerifyM'
import InviteRankingM from '@/components/InviteRankingM'
import AgmAffirm from '@/components/livePc/AgmAffirm'
import { ImagePreview } from 'vant'

let chatId = 1
let timer = null
export default {
    name: 'live-m',
    props: ['userInfo', 'goodsCourseInfo', 'courseNo', 'courseId', 'courseToken', 'liveCoursePackage', 'envWebview'],
    components: {
        LuckDraw,
        OrderVerifyM,
        CoursePackageList,
        Barrage,
        InviteRankingM,
        ExceptionView,
        AgmAffirm,
        OrderDialog,
    },
    data() {
        return {
            isWeixin: isWeixin(),
            isShowNotice: false,
            noticeMessage: '',
            iphoneX: isIphoneX(),
            inputFocusStatus: false,
            isInputStatus: true,
            // 0默认 -1未开始 1开始
            liveStatus: 1,
            countDownText: '',
            courseInfo: {},
            activeTabItem: 'chat',
            chatList: [],
            isNewMessage: {
                chat: false,
                question: false,
            },
            questionList: [],
            chatMessage: '',
            questionMessage: '',
            HT_userInfo: {},
            luckDrawStatus: 0,
            luckDrawUserName: '',
            // 推送商品相关参数
            pushProductList: [],
            pushPackageInfo: {},

            // 直播间设置
            networkLineList: [],
            activeLine: 0,
            activeNetwork: 'HLS',
            networkModalList: [
                { name: '稳定模式', val: 'HLS', type: 'techOrder' },
                { name: '极速模式', val: 'FLV', type: 'techOrder' },
            ],
            rewardNoticeText: '',
            isShowRewardPrice: false,
            barrageData: [],

            isShowShareContainer: false,
            userClickShareBtn: false,

            // 横屏后全屏操作
            isHorizontal: false,
            horizontalFull: false,
            exceptionType: '',
        }
    },
    created() {
        this.rewardNoticeTextList = []
        this.isPageBottm = false
        this.getLiveInfoApi()

        // 横竖屏 切换
        this.onResize()
        window.onresize = this.onResize
    },
    methods: {
        onResize() {
            const width = document.documentElement.clientWidth
            const height = document.documentElement.clientHeight
            if (width >= 540 && width / height > 1.2) {
                this.isHorizontal = true
                this.horizontalFull = false
            } else {
                this.isHorizontal = false
                this.horizontalFull = false
            }
        },
        onPreviewImage(event) {
            // 图片预览
            if (event.target.nodeName === 'IMG' && event.target.src) {
                ImagePreview({
                    images: [event.target.src],
                    swipeDuration: 120,
                })
            }
        },
        onShowShareContainer() {
            if (this.isWeixin) {
                this.isShowShareContainer = true
            } else {
                this.$toast('请复制地址分享给朋友～～')
            }
            this.userClickShareBtn = true
        },
        onHorizontalFull() {
            this.horizontalFull = !this.horizontalFull
        },
        onTabchange(type) {
            if (this.activeTabItem !== type) {
                this.activeTabItem = type
                this.isNewMessage[type] = false
            }
        },
        onTextareaBlur() {
            this.inputFocusStatus = false
            setTimeout(() => {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
                window.scrollTo(0, Math.max(scrollHeight - 1, 0))
            }, 100)
        },
        onSubmitChat() {
            if (!this.isInputStatus) return false
            if (this.LIVESDK) {
                if (this.userForbiddenTalk) {
                    this.updateChatList([{ ...this.HT_userInfo, time: Date.now() / 1000, msg: this.chatMessage }])
                    this.chatMessage = ''
                } else {
                    this.LIVESDK.emit('chat:send', { type: 'matchKey', msg: this.chatMessage }, (res) => {
                        if (Number(res.code) === 0) {
                            this.updateChatList([res.data])
                            this.chatMessage = ''
                        } else {
                            this.$toast(res.msg || '发送消息失败')
                        }
                    })
                }
            } else {
                this.$toast('发送消息失败，账号未登录')
            }
        },
        onSubmitQuestion() {
            if (this.LIVESDK) {
                this.LIVESDK.emit('question:ask', { msg: this.questionMessage }, (res) => {
                    if (Number(res.code) === 0) {
                        this.$toast({
                            className: 'success-toast',
                            message: '提问成功',
                        })
                    } else {
                        this.$toast(res.msg || '发送消息失败')
                    }
                })
                this.questionMessage = ''
            } else {
                this.$toast('提问失败，账号未登录')
            }
        },
        onSetLuckDrawStatus(status) {
            this.luckDrawStatus = status
            if (status === 0) {
                this.luckDrawUserName = ''
            }
        },
        onBuyCoursePackage(item) {
            this.pushPackageInfo = item
            if (this.envWebview === 'app') {
                buyCoursepackage(item.packageNo, this.goodsCourseInfo.liveId)
            } else if (this.envWebview === 'applet') {
                const url = `/pages/coursePay/coursePay?liveId=${this.goodsCourseInfo.liveId}&packageNo=${item.packageNo}`
                window.wxSdk.miniProgram.navigateTo({ url: url })
            } else {
                const _options = urlQuery()
                if (_options.agmVersion === 'old') {
                    this.$refs.orderVerifyM.onShow()
                } else {
                    this.$refs.orderDialog.onShow({
                        productInfo: {
                            onSale: item.onSale,
                            productNo: item.packageNo,
                            productType: 1,
                        },
                        userInfo: this.userInfo,
                        liveId: this.goodsCourseInfo.liveId,
                        sn: _options.sn,
                    })
                }
            }
        },
        onResetPage() {
            window.location.reload()
        },
        onRewardPay(price) {
            const { userInfo, goodsCourseInfo } = this
            // 正常支付
            const params = {
                userId: userInfo.id,
                productType: 2,
                openId: userInfo.openId,
                productNo: goodsCourseInfo.courseNo,
                appId: window.WX_APPID,
                orderDetail: {
                    payFee: parseFloat(price) * 100,
                    tradeType: 'JSAPI',
                    tradeProvider: 'wxpay',
                },
            }
            fetchOrder(params).then((res) => {
                wxPay(
                    {
                        ...res.data,
                        package: res.data.packageValue,
                    },
                    (data) => {
                        if (data.err_msg == 'get_brand_wcpay_request:ok') {
                            this.$toast({
                                className: 'success-toast',
                                message: '打赏成功',
                                duration: 2000,
                            })
                        } else if (data.err_msg == 'get_brand_wcpay_request:fail') {
                            this.$toast('支付失败')
                        }
                        this.isShowRewardPrice = false
                    }
                )
            })
        },
        updateChatList(chatList) {
            const list = []
            chatList.forEach((chat) => {
                // 伪直播不显示当前用户数据
                let state = chat.old !== 1
                if (!state) {
                    state = this.HT_userInfo.uid !== chat.uid
                }
                if (chat.msg && state) {
                    chat.chatId = chatId++
                    // 时间格式化
                    if (chat.time) chat.timeText = timeToHourMins(chat.time)
                    // 对链接进行支持跳转
                    if (['spadmin', 'admin'].indexOf(chat.role) !== -1 && chat.msg.indexOf('[IMG]') == -1) {
                        chat.msg = replaceUrl(chat.msg)
                    }
                    // 表情处理
                    chat.msg = getLivEmojions(chat.msg)
                    // 图片处理
                    if (chat.msg.indexOf('[IMG]') != -1) {
                        const imgUrl = chat.msg.replace(/\[IMG\]|\[\/IMG\]/g, '')
                        chat.msg = `<img src="${imgUrl}" />`
                    }
                    // 广播地址处理
                    if (chat.thirdType === 'broadcast') chat.msg = replaceUrl(chat.msg)
                    list.push(chat)
                }
            })
            this.updateChatDom(list)
        },
        updateChatDom(chatList) {
            const content = this.$refs.chatListContent
            const box = this.$refs.chatListBox
            const scrollStatus = box.scrollHeight - content.scrollTop - content.clientHeight
            // 评论触底是否
            if (scrollStatus <= 10) this.isPageBottm = true
            if (this.chatList.length < 300) {
                this.chatList.push(...chatList)
            } else {
                this.chatList = [...this.chatList.slice(-100), ...chatList]
            }
            // 如果有新消息 且用户不在当前菜单则提示
            if (this.activeTabItem !== 'chat') {
                this.isNewMessage.chat = true
            }
            this.$nextTick(() => {
                if (this.isPageBottm) {
                    content.scrollTop =
                        this.$refs.chatListBox.scrollHeight - this.$refs.chatListContent.clientHeight - 1
                }
            })
        },
        updateQuestionList(questions, type) {
            let list = [...this.questionList]
            if (type === 'list') {
                list = []
                Object.keys(questions).forEach((item) => {
                    questions[item].timeText = timeToHourMins(questions[item].time)
                    // 对链接进行支持跳转
                    if (['spadmin', 'admin'].indexOf(questions[item].role) !== -1) {
                        questions[item].content = replaceUrl(questions[item].content)
                    }
                    if (questions[item].answer) {
                        questions[item].answer.forEach((answerItem) => {
                            if (['spadmin', 'admin'].indexOf(answerItem.role) !== -1) {
                                answerItem.content = replaceUrl(answerItem.content)
                            }
                        })
                    }
                    list.push({ ...questions[item] })
                })
            } else if (type === 'reply') {
                list.forEach((item) => {
                    if (item.qid === questions.replyId) {
                        item.answer = item.answer || []
                        if (['spadmin', 'admin'].indexOf(questions.role) !== -1) {
                            questions.content = replaceUrl(questions.content)
                        }
                        item.answer.push(questions)
                    }
                })
                if (questions.question.uid === this.HT_userInfo.uid) {
                    this.$toast({ className: 'success-toast', message: '老师刚刚回复了您的问题' })
                }
            } else if (type === 'del') {
                const newList = []
                list.forEach((item) => {
                    let delIndex = -1
                    if (item.answer) {
                        item.answer.forEach((answerItem, index) => {
                            if (answerItem.qid == questions.qid) {
                                delIndex = index
                            }
                        })
                    }
                    if (delIndex !== -1) {
                        item.answer.splice(delIndex, 1)
                    }
                    if (item.qid !== questions.qid) {
                        newList.push(item)
                    }
                })
                list = newList
            } else {
                let status = true
                list.forEach((item) => {
                    if (item.qid === questions.qid) {
                        status = false
                    }
                })
                if (status) {
                    if (['spadmin', 'admin'].indexOf(questions.role) !== -1) {
                        questions.content = replaceUrl(questions.content)
                    }
                    questions.timeText = timeToHourMins(questions.time)
                    list.push(questions)
                } else {
                    return
                }
            }
            this.questionList = list
            // 如果有新消息 且用户不在当前菜单则提示
            if (this.activeTabItem !== 'question' && (!questions || questions.length !== 0)) {
                this.isNewMessage.question = true
            }
        },
        chatTouch() {
            const content = this.$refs.chatListContent
            const box = this.$refs.chatListBox
            const scrollNum = box.scrollHeight - content.scrollTop - content.clientHeight
            if (scrollNum > 100) {
                this.isPageBottm = false
            }
        },
        getLiveInfoApi() {
            getLiveInfo(this.courseToken).then((res) => {
                liveInit(this, res.data.accessToken, this.liveCoursePackage)
                this.liveHeartApi()
                this.checkLiveState(res.data.expireIn)
                if (res.data.agreementStatus && res.data.agreementStatus.needCertNo) {
                    this.$refs.agmAffirm.onShow(res.data.agreementStatus)
                }
            })
            // 查询禁言状态
            getLiveForbidden(this.userInfo.id).then((res) => {
                if (res.data.forbiddenTalk) {
                    this.userForbiddenTalk = true
                } else {
                    this.userForbiddenTalk = false
                }
            })
        },
        stopTouch(event) {
            event.preventDefault()
            event.stopPropagation()
        },
        // 线路切换
        onLineChange(item) {
            this.activeLine = item.key
            this.onSwitchNetwork({ val: item.key, type: 'network' })
        },
        // 网络模式切换
        onNetworkChange(item) {
            this.activeNetwork = item.val
            this.onSwitchNetwork(item)
        },
        onSwitchNetwork(data) {
            this.$toast.loading({ duration: 0, message: '加载中...' })
            if (data.type === 'network') {
                this.LIVESDK.setLine(data.val)
            } else if (data.type === 'techOrder') {
                this.LIVESDK.playerTechOrder(data.val)
            }

            setTimeout(() => {
                this.$toast.clear()
            }, 2000)
        },
        setLiveStartBg() {
            if (document.getElementById('tf-xplay-icon')) {
                const icon = document.getElementById('tf-xplay-icon')
                icon.style.cssText = `background-image: url(${this.goodsCourseInfo.coverUrl}) !important`
                document.getElementById('tf-xplay-icon').style.backgroundColor = 'none'
                // 视频开始后，封面无法点击隐藏
                document.getElementById('tf-xplay-icon').addEventListener('click', function () {
                    document.getElementById('tf-xplay-icon').style.display = 'none'
                })
            }
        },
        onScrollMessage() {},
        // 打赏
        updateReward(msg) {
            // 滚动中
            if (this.rewardNoticeText) {
                this.rewardNoticeTextList.push(msg)
            } else {
                this.rewardNoticeText = msg
                setTimeout(() => {
                    this.rewardNoticeText = ''
                    if (this.rewardNoticeTextList.length != 0) {
                        this.$nextTick(() => {
                            this.updateReward(this.rewardNoticeTextList.shift())
                        })
                    }
                }, 5200)
            }
        },
        liveHeartApi() {
            timer = setInterval(() => {
                liveHeart({
                    uid: this.userInfo.id,
                    cid: this.goodsCourseInfo.id,
                })
                    .then(() => {})
                    .catch(() => {})
                this.$emit('showEvaluate')
            }, 30 * 1000)
        },

        // 判断是否试听地址， 对于试听课程进行倒计时判断，超出时间的直接踢出直播间
        checkLiveState(_timeNum) {
            if (_timeNum && _timeNum > 0) {
                console.log('试听地址 开始计时', timeNumToHMSText(parseInt(_timeNum / 1000)))
                setInterval(() => {
                    this.onShowExceptionView('试听已结束')
                }, _timeNum)
            }
        },
        onShowExceptionView(val) {
            clearInterval(timer)
            this.exceptionType = val
            if (this.LIVESDK) this.LIVESDK.destroy()
        },
    },
}
</script>

<style lang="scss">
html,
body,
.live-m,
.main {
    background: #eee;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}
#whiteboard-content {
    display: none;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 0;
}
.main {
    display: flex;
    flex-direction: column;
    position: relative;
    .loading-container {
        width: 100%;
        height: 56.25vw;
        max-height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        z-index: 1;
    }
    .van-notice-bar {
        width: 100%;
        flex-shrink: 0;
        box-sizing: border-box;
    }
    .player-container {
        width: 100%;
        height: 56.25vw;
        max-height: 100vh;
        position: relative;
        z-index: 2;
        #tf-xplay-icon {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 100;
            top: 0px;
            left: 0px;
            background-repeat: no-repeat;
            background-position: 50% 50%;
            background-image: none !important;
            background-color: #eee;
            background-size: cover;
            &::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                width: 90px;
                height: 90px;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;
                transform: translate(-50%, -50%);
                background-image: url('https://res.peki.vip/20210428/1619583518124/1619583518126.png');
            }
        }
        .tf-x-controls {
            display: none;
        }
        #maituoPlayer {
            height: 100% !important;
        }
    }
    .tab-list {
        display: flex;
        align-items: center;
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        border-bottom: 1px solid #dddddd;
        background: #fff;
        position: relative;
        flex-shrink: 0;
        z-index: 10;
        div {
            width: 60px;
            text-align: center;
            position: relative;
        }

        .active-item {
            color: #44cd94;
            font-weight: 700;
            &::after {
                content: '';
                position: absolute;
                bottom: 4px;
                width: 16px;
                height: 2px;
                border-radius: 2px;
                background: #44cd94;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        .setting {
            position: absolute;
            right: 10px;
            font-size: 18px;
            width: 20px;
            display: flex;
            height: 100%;
            align-items: center;
            &::after {
                content: '';
                display: none;
            }
        }
        .new-message-icon::before {
            content: '';
            position: absolute;
            width: 6px;
            height: 6px;
            background: red;
            top: 10px;
            right: 8px;
            border-radius: 50%;
        }
        .red-packet {
            position: absolute;
            top: 50%;
            transform: translateY(-50%) scale(0.9);
            right: 45px;
            width: 18px;
            height: 18px;
            display: flex;
            font-size: 12px;
            color: #ff0000;
            font-weight: 700;
            align-items: center;
            justify-content: center;
            border: 1px solid #ff0000;
            border-radius: 50%;
        }
        .reset-page {
            font-size: 12px;
            color: #999;
        }
        .share-icon {
            width: 28px;
            height: 28px;
            margin-left: 10px;
        }
    }
    .tab-list .reward-price {
        height: 60px;
        width: 100% !important;
        position: absolute;
        top: 40px;
        left: 0;
        background: #fff;
        display: flex;
        justify-content: space-around;
        align-items: center;
        z-index: 9;
        > div {
            width: auto;
            height: 21px;
            line-height: 21px;
            padding: 0 6px;
            border-radius: 4px;
            color: #ee0a24;
            font-weight: 700;
            border: 1.5px solid #ee0a24;
        }
    }
    .question-list,
    .chat-list {
        flex-grow: 1;
        width: 100%;
        background: #eee;
        margin-bottom: 56px;
        position: relative;
        min-height: 180px;
        box-sizing: border-box;
        .list-content {
            position: absolute;
            width: 100%;
            height: 100%;
            overflow-y: scroll;
            bottom: 0;
            .list-item {
                display: flex;
                padding: 10px 0;
                margin: 0 15px;
            }
            .user-avatar {
                width: 40px;
                height: 40px;
                margin-right: 10px;
                flex-shrink: 0;
                border-radius: 4px;
            }
            .user-info {
                display: flex;
                font-size: 13px;
            }
            .user-name {
                font-size: 13px;
                color: #333;
            }
            .user-role1 {
                color: #44cd94;
            }
            .user-role2 {
                color: #ee0a24;
            }
            .user-role3 {
                color: #ff976a;
            }
            .chat-message {
                font-size: 13px;
                color: #000000;
                margin-top: 6px;
                word-break: break-all;
                background: #fff;
                display: inline-block;
                padding: 5px 10px;
                line-height: 1.4em;
                border-radius: 2px;
                margin-bottom: 10px;
                max-width: 270px;
                min-height: 1.4em;
                min-width: 5px;
                position: relative;
                &::after {
                    content: '';
                    position: absolute;
                    background: #fff;
                    width: 10px;
                    height: 10px;
                    border-radius: 1px;
                    top: 5px;
                    left: -3px;
                    transform: rotate(60deg);
                }
                &.admin-chat-message {
                    background: #3ac9ab;
                    color: #fff;
                }
                &.admin-chat-message::after {
                    background: #3ac9ab;
                }
                a {
                    text-decoration: underline;
                }
                // getLivEmojions替换表情
                .emoj-icon {
                    width: 30px;
                    display: inline-block;
                    margin: 0 4px;
                }
            }
            .admin-message {
                font-weight: 600;
                color: #ff0000;
            }
            .question-message {
                min-width: 250px;
                a {
                    color: #00aeef;
                    text-decoration: underline;
                }
            }
            .question-answer {
                margin-top: 9px;
            }
            .message-time {
                font-size: 14px;
                color: #333;
                margin-left: 20px;
            }
            .broadcast-item {
                padding: 0 10px;
                line-height: 1.6em;
                font-size: 14px;
                font-weight: 700;
                color: #1989fa;
                word-break: break-all;
                span {
                    color: #333;
                }
            }
            .userToPay-item {
                line-height: 1.6em;
                font-size: 14px;
                span {
                    font-weight: 700;
                }
                .nickname {
                    color: #ff4040;
                }
            }
        }
    }
    .question-list-iphoneX,
    .chat-list-iphoneX {
        margin-bottom: 86px;
    }
    .barrage-container {
        position: absolute;
        width: 100%;
        height: 150px;
        z-index: 1;
        pointer-events: none;
    }
    .setting-container {
        padding: 20px;
        .setting-item {
            display: flex;
            margin-bottom: 20px;
            > span {
                line-height: 32px;
                width: 70px;
                flex-shrink: 0;
                font-size: 14px;
            }
            .network-btn {
                height: 32px;
                margin-right: 12px;
                font-size: 13px;
                padding: 0 12px;
                height: 32px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
}

.chat-dialog {
    position: fixed;
    z-index: 12;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 0 12px;
    align-items: center;
    box-sizing: border-box;
    transition: all 0.2s;
    box-shadow: 1px -4px 10px rgba(240, 236, 236, 0.5);
    textarea {
        flex-grow: 1;
        height: 33px;
        font-size: 13px;
        padding: 9px;
        box-sizing: border-box;
        border-radius: 3px;
        border: 1px solid #bbb;
        outline: none;
        resize: none;
        appearance: none;
        line-height: 1em;
        border: 1px solid rgba(201, 198, 198, 1);
    }
    .submit-btn {
        flex-shrink: 0;
        font-size: 14px;
        font-weight: 700;
        width: 72px;
        height: 33px;
        line-height: 33px;
        border-radius: 3px;
        text-align: center;
        background: #20c6a7;
        color: #fff;
        margin-left: 7px;
        &.disabled-btn {
            background: rgba(201, 198, 198, 1);
        }
    }
}
.chat-dialog-iphoneX {
    padding: 0 15px 34px;
    height: 85px;
}
.share-btn {
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    bottom: 280px;
    right: 10px;
    z-index: 200;
    font-size: 12px;
    line-height: 1.8em;
    font-weight: 700;
    color: #20c6a7;
    img {
        width: 42px;
        height: 42px;
        flex-shrink: 0;
    }
    span {
        white-space: nowrap;
    }
}
.share-container {
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.8);
    position: fixed;
    box-sizing: border-box;
    top: 0;
    left: 0;
    z-index: 9999;
    img {
        width: 100%;
        margin: 0 auto;
        max-width: 100vh;
    }
}

@media all and (orientation: landscape) and (min-aspect-ratio: 16/10) {
    .share-btn {
        position: fixed;
        top: 30%;
        transform: translateY(-50%);
        img {
            width: 48px;
            height: 48px;
            flex-shrink: 0;
        }
        span {
            font-size: 12px;
            transform: scale(0.8);
        }
    }
}

// 横版
.horizontal {
    .main {
        flex-direction: row;
        .van-notice-bar {
            width: calc(100vw - 280px);
            left: 0;
            position: absolute;
            top: 0;
            z-index: 19;
        }
        .loading-container,
        .player-container {
            width: calc(100vw - 280px) !important;
            height: 100%;
        }
        .horizontal-full-btn {
            position: absolute;
            top: 40%;
            z-index: 9;
            width: 16px;
            transform: rotate(0);
            right: 264px;
        }
        .horizontal-full-btn-left {
            right: 0;
            transform: rotate(180deg);
        }
        .tab-list {
            position: absolute;
            right: 0;
            width: 280px;
            z-index: 9;
        }
        .question-list,
        .chat-list {
            background: #ffffff;
            width: 280px;
            margin-bottom: 50px;
            .list-content {
                padding-top: 50px;
                box-sizing: border-box;
                .chat-message {
                    max-width: 180px;
                }
                .question-message {
                    max-width: 180px;
                    min-width: 160px;
                }
            }
        }
        .barrage-container {
            top: 50px;
            height: 50%;
        }
        .setting-container {
            background: #ffffff;
            width: 280px;
            box-sizing: border-box;
            padding: 50px 15px 15px;
        }
        .inviteRanking {
            background: #ffffff;
            width: 280px;
            .ranking-container {
                top: 120px;
            }
            .ranking-bg {
                top: 0;
                height: 100%;
            }
            .ranking-bg2 {
                height: 100%;
            }
        }
    }
    .chat-dialog {
        width: 280px;
        right: 0;
        left: initial;
    }
}
.horizontalFull {
    .main {
        .loading-container,
        .van-notice-bar,
        .player-container {
            width: 100vw !important;
        }
        .chat-list,
        .setting-container,
        .question-list,
        .inviteRanking,
        .tab-list {
            display: none !important;
        }
    }
    .chat-dialog {
        display: none;
    }
}
#player-content {
    width: 100%;
    height: 100%;
}
</style>
